import { Component, OnInit } from '@angular/core';
import { ServerService } from '../services/server.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
declare var iziToast: any;
declare var $: any;
import Swal from 'sweetalert2';
declare var tinymce: any;
import * as Feather from 'feather-icons';
@Component({
  selector: 'app-support-ticket-list',
  templateUrl: './support-ticket-list.component.html',
  styleUrls: ['./support-ticket-list.component.css']
})
export class SupportTicketListComponent implements OnInit {
  recordNotFound = false;
  pageLimit = 50;
  paginationData: any = { "info": "hide" };
  offset_count = 0;
  counts: any = {};
  recordNotFound2 = false;
  pageLimit2 = 10;
  paginationData2: any = { "info": "hide" };
  offset_count2 = 0;
  tickets: any = [];
  files: any = [];
  filesend: any = [];
  createinformation: FormGroup;
  value;
  customerdetails: any = {};
  datadetails: any;
  param1: any;
  param2: any;
  table = false;
  close_table = false;
  new_table = false;
  countryList:any;
  priorityList:any;
  supportRequestTypeList:any;
  create_ticket_loader =false;
 
  constructor(private router: Router,  private http: HttpClient,
 private serverService: ServerService, private route: ActivatedRoute,) {
    this.param1 = this.route.snapshot.queryParamMap.get('name');
    this.param2 = this.route.snapshot.queryParamMap.get('id');
    this.serverService.emailcount.subscribe( (val:any) => 
    {
      this.create_ticket_loader=true;
          console.log(val);
          this.ticket_count();
    })
  }

  ngOnInit(): void {
   
    this.serverService.popup.subscribe((val: any) => {
      console.log(val);
      let viewContent = JSON.parse(val);
      console.log(viewContent);
      if (viewContent.type === 'create_ticket') {
        $('#addNewPopup').modal('show');
        this.jiraDropdown();
      }
    });
    this.jiraDropdown();
    this.countryflag();
    this.serverService.ticketRefresh.subscribe(() => {
      console.log('Ticket refresh triggered');
      this.helpDeskTickets('NEW');
    });
    this.helpDeskTickets('NEW');
    this.ticket_count();
    this.initTiny();
    
    this.createinformation = new FormGroup({
      'fromticket': new FormControl(null,
        Validators.required),
      'department': new FormControl(null),
      'country':new FormControl(null, Validators.required),
      'priority': new FormControl(null, Validators.required),
      'requestType':new FormControl(null, Validators.required),
      'subject': new FormControl(null, Validators.required),
      'messages': new FormControl(null)

    });
    this.param1 = atob(this.param1)
    this.param2 = atob(this.param2)
    if (this.param1 == 'open') {
      this.table = true;
    }
    if (this.param2 == 'new') {
      this.new_table = true;
    }
    if (this.param2 == 'closed') {
      this.close_table = true;
    }
    $('.tile').click(function() {
      $(this).addClass('active-filter').siblings().removeClass('active-filter');
    
  });
  let selectDisplay: any = localStorage.getItem('selectDisplay');
    if(selectDisplay == "close-counts"){
      $('#open-counts').removeClass('active-filter');
      $('#close-counts').addClass('active-filter')
    }
  }

  ngAfterViewInit() {
    Feather.replace();
  }

  finishFunction() {

    console.log(this.createinformation.value)
    if (this.createinformation.valid) {

      this.createnewticket()
    }
    else {

      this.validateAllFields(this.createinformation);
    }
    this.createinformation.reset(); 
  }



  validateAllFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFields(control);
      }
    });
  }


  localUrl;
  file: File;
  uploadFiless(event) {
    console.log(event[0])
    this.file = event[0];
    if (event[0] != undefined) {
      this.filesend.push(event[0])

    }

    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      this.files.push(element.name);
    }
    console.log(this.filesend)




  }



  uploadFile(event: any) {
    this.file = event.target.files[0];

    console.log(this.file)
    if (this.file != undefined) {

      this.filesend.push(this.file)
    }
    var events = event.target.files;
    for (let index = 0; index < events.length; index++) {
      const element = events[index];
      this.files.push(element.name)
    }

    console.log(this.filesend)

  }



  deleteAttachment(i) {
    this.files.splice(i, 1)
    this.filesend.splice(i, 1);
  }


  gotck(ticket) {
    var tck = btoa(ticket);
    $('.pointer').addClass('read-color-change');
    // localStorage.setItem('tck',tck); 
    this.router.navigate(['support-ticket-list-thread'], { queryParams: { id: tck } });

  }

selectDisplay(event: Event, status: string): void {

  const tiles = document.querySelectorAll('.ticket-section .tile');

  tiles.forEach((tile) => {
    tile.classList.remove('active-filter');
  });

  const clickedTile = event.currentTarget as HTMLElement;
  clickedTile.classList.add('active-filter');

  let ticketFlag: string = '';

  switch (status) {

    case 'new-counts':
      ticketFlag = 'NEW';
      break;

    case 'open-counts':
      ticketFlag = 'OPEN';
      break;

    case 'queue-counts':
      ticketFlag = 'IN_PROGRESS';
      break;

    case 'close-counts':
      ticketFlag = 'RESOLVED';
      break;
  }

  console.log('Selected ticket flag:', ticketFlag);

  this.helpDeskTickets(ticketFlag);
}



helpDeskTickets(ticketFlag: string): void {

  Swal.fire('Please wait');
  Swal.showLoading();

  const list_data = this.listDataInfo({});

  const customer_id = localStorage.getItem('en');

  const apiUrl = 'https://erp.cal4care.com/cms_new/api_cms/v1.0/index.php';

  const payload = {
    access_token: 'NTQ4OSMjIzhkYzEwZGFkYjExYjdjOGNjMTgy',
    operation: 'helpDeskCurl',
    moduleType: 'ticket',
    api_type: 'web',
    element_data: {
      action: 'helpdesk_ticket',
      customer_id: customer_id,
      ticket_flag: ticketFlag,
      limit: this.pageLimit,
      offset: 0
    }
  };

  this.http.post(apiUrl, payload).subscribe(
    (response: any) => {

      console.log('API Response:', response);

      Swal.close();

      if (response.result && response.result.status === true) {

        const data = response.result.data;



        // ==============================
        // Ticket list
        // ==============================
        const ticketData = data.ticket_data || [];

        this.tickets = ticketData.map((ticket: any) => {

          return {
            ticket_no: ticket.number,
            ticket_subject: ticket.subject,
            created_dt: ticket.createdAt,
            status_desc: ticket.status,
            department_name: ticket.departmentName,
            ticket_from: ticket.requesterEmail,

            // Keep original API object
            ...ticket
          };

        });
        this.ticket_count();
        console.log('Mapped tickets:', this.tickets);

        // ==============================
        // Pagination
        // ==============================
        this.offset_count = list_data.offset;

        this.paginationData = this.serverService.pagination({
          offset: data.offset || 0,
          total: data.total || 0,
          page_limit: this.pageLimit
        });

        this.recordNotFound = this.tickets.length === 0;

      } else {

        this.tickets = [];

        this.counts = {
          new: 0,
          open: 0,
          in_progress: 0,
          resolved: 0
        };

        this.recordNotFound = true;
      }
    },
    (error) => {

      Swal.close();

      console.log('API Error:', error);

      this.tickets = [];

      this.counts = {
        new: 0,
        open: 0,
        in_progress: 0,
        resolved: 0
      };

      this.recordNotFound = true;
    }
  );
}




  listDataInfo(list_data) {
    console.log(list_data)
    list_data.search_text = list_data.search_text == undefined ? "" : list_data.search_text;
    list_data.limit = list_data.limit == undefined ? this.pageLimit : list_data.limit;
    list_data.offset = list_data.offset == undefined ? 0 : list_data.offset;
    return list_data;
  }
  createticket() {
    this.files = [];
    this.filesend = [];
    this.file = null;
    tinymce.get('richTextAreacreated').setContent('');
    let api_reqs:any = '{"type": "create_ticket"}';
    this.serverService.createticket.next(api_reqs);
    $('#addNewPopup').modal('show');
  }
  countryflag() {
    let data: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');
    data.action = "customer_data";
    data.customer_id = customer_id;
    datasend.access_token = access_token;
    datasend.operation = "curlDatas";
    datasend.moduleType = "login";
    datasend.api_type = "web";
    datasend.element_data = data;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      console.log(response)
      if (response.status == "true") {
        this.customerdetails = response.customer_data;
        this.datadetails = response;
        this.createinformation.patchValue({
          fromticket: this.customerdetails.customerName,
          department: localStorage.getItem('dept_name')

        });
      }
      else {
      }
    },
      (error) => {
        console.log(error);
      });
  }
  jiraDropdown() {
    let data: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');
    data.action = "omni_dropdown";
    data.customer_id = customer_id;
    datasend.access_token = access_token;
    datasend.operation = "omniCurl";
    datasend.moduleType = "ticket";
    datasend.api_type = "web";
    datasend.element_data = data;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      console.log(response)
      if (response.status == "true") {
        this.countryList=response.country;
        this.priorityList=response.priority;
        this.supportRequestTypeList=response.type;
      }
      else {

      }
    },
      (error) => {
        console.log(error);
      });
  }

  createnewticket() {
    Swal.fire('Please wait')
    Swal.showLoading()
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');
    let cms_login_email =  localStorage.getItem('cms_login_email');
    // var department_id = localStorage.getItem('dept');
    var department_id = '103';
    const forms = new FormData();
    var msg_id = tinymce.get('richTextAreacreated').getContent();
    forms.append('name', this.customerdetails.customerName);
    if(cms_login_email){
      forms.append('email', cms_login_email);
    }
    else{
      forms.append('email', this.datadetails.email_id);
    }
    forms.append('dept_id', department_id);
    forms.append('customer_contact', localStorage.getItem('customer_contact'));
    forms.append('country_id',  this.createinformation.value.country);
    forms.append('priority_id',  this.createinformation.value.priority);
    forms.append('typeid',  this.createinformation.value.requestType);
    forms.append('subject', this.createinformation.value.subject);
    // forms.append('message', this.createinformation.value.messages.replace(/<(?:.|\n)*?>/gm, ' '));
    forms.append('message', msg_id);
    // forms.append('custs_id',  this.datadetails.customer_id);
    forms.append('custs_id', customer_id);
    forms.append('custs_code', this.customerdetails.customerCode);

    for (var i = 0; i < this.filesend.length; i++) {
      forms.append('attachment[' + i + ']', this.filesend[i]);
    }

    forms.append('action', 'cms_create_ticket');
    forms.append('access_token', access_token);
    forms.append('api_type', 'web');

    console.log(forms);
    var self = this;
    $.ajax({
      url: "https://erp.cal4care.com/cms_new/api_cms/v1.0/index_new.php",
      type: 'POST',
      data: forms,
      processData: false,  // tell jQuery not to process the data
      contentType: false,
      success: function (data) {
        console.log(data)

        self.ticket_count()
        $('#addNewPopup').modal('hide');
        Swal.close();
        iziToast.success({
          message: "Ticket Created Successfully",
          position: 'topRight'
        });
        console.log("Hello from setTimeout");

      }
    });

  }


  ticket_count(){
  const list_data = this.listDataInfo({});
  const customer_id = localStorage.getItem('en');
  const apiUrl = 'https://erp.cal4care.com/cms_new/api_cms/v1.0/index.php';
  const payload = {
    access_token: 'NTQ4OSMjIzhkYzEwZGFkYjExYjdjOGNjMTgy',
    operation: 'helpDeskCurl',
    moduleType: 'ticket',
    api_type: 'web',
    element_data: {
      action: 'helpdesk_ticketCount',
      customer_id: customer_id,
    }
  };

  this.http.post(apiUrl, payload).subscribe(
    (response: any) => {
      console.log('API Response:', response);
      if (response.result && response.result.status === true) {

        const data = response.result.data;

        // ==============================
        // Ticket count
        // ==============================
        const total = data.total || 0;

        console.log('Total Tickets:', total);

        // ==============================
        // Status counts
        // ==============================
        const statusCounts = data.status_counts || {};

        this.counts = {
          new: statusCounts.NEW || 0,
          open: statusCounts.OPEN || 0,
          in_progress: statusCounts.IN_PROGRESS || 0,
          resolved: statusCounts.RESOLVED || 0
        };

        console.log('Ticket Counts:', this.counts);
      }

    });
  } 




  onMessageSend($event) {
    if ($event.keyCode != '') {
      $event.stopPropagation();
      return false;
    }


  }
  initTiny() {
    var richTextArea_id = 'richTextAreacreated';
    tinymce.init({
      selector: '#richTextAreacreated',
      height: 500,
      plugins: 'advlist autolink textcolor formatpainter lists link  image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste  wordcount autolink lists media table',
      toolbar: 'undo redo |fullscreen|forecolor backcolor| formatselect | bold italic | \ undo redo | link image file| code | \
       alignleft aligncenter alignright alignjustify | \
       bullist numlist outdent indent | autoresize',
      paste_data_images: true,
      images_upload_url: 'upload.php',
      automatic_uploads: false,
      default_link_target: "_blank",
      extended_valid_elements: "a[href|target=_blank]",
      link_assume_external_targets: true,
      images_upload_handler: function (blobInfo, success, failure) {
        var xhr, formData;

        xhr = new XMLHttpRequest();
        xhr.withCredentials = false;
        xhr.open('POST', 'upload.php');

        xhr.onload = function () {
          var json;

          if (xhr.status != 200) {
            failure('HTTP Error: ' + xhr.status);
            return;
          }

          json = JSON.parse(xhr.responseText);

          if (!json || typeof json.file_path != 'string') {
            failure('Invalid JSON: ' + xhr.responseText);
            return;
          }

          success(json.file_path);
        };

        formData = new FormData();
        formData.append('file', blobInfo.blob(), blobInfo.filename());

        xhr.send(formData);
      },
    });
    if (tinymce.editors.length > 0) {
      //  tinymce.execCommand('mceFocus', true, richTextArea_id );       
      tinymce.execCommand('mceRemoveEditor', true, richTextArea_id);
      tinymce.execCommand('mceAddEditor', true, richTextArea_id);
    }
  }


}


